import moment from 'moment'
import { formatCurrency } from '../../pages/DataEntryPage/utils/currency'
import {
  getFieldId,
  getLegacySubfieldId,
  getLegacySubfieldReviewId,
} from '../../pages/DataEntryPage/utils/utils'
import { FIELD_TYPES, FORMATS } from '../../utility/constants'

export const getFieldsForSettings = (subfields) => {
  let columnsForGroupBy = []
  let columnsForSetting = []
  let selectTotalArr = []

  for (const subfield of subfields) {
    if (subfield.data_structure === FIELD_TYPES.LIST) {
      columnsForGroupBy.push({
        path: subfield.id + '__',
        name: subfield.field_template_name,
        sequence: subfield.sequence,
        children: subfield.childFieldIds,
      })
    }

    if (
      subfield.data_structure === FIELD_TYPES.NUMBER ||
      subfield.data_structure === FIELD_TYPES.CURRENCY
    ) {
      selectTotalArr.push({
        path: subfield.id,
        name: subfield.field_template_name,
        sequence: subfield.sequence,
        children: subfield.childFieldIds,
      })
    }

    columnsForSetting.push({
      path: subfield.id + '__',
      name: subfield.field_template_name,
      sequence: subfield.sequence,
      children: subfield.childFieldIds,
      is_hidden: subfield.is_hidden,
      subfield_width: subfield.subfield_column_width_in_rem,
    })
  }
  return { columnsForGroupBy, columnsForSetting, selectTotalArr }
}

export const normalizeDataForGroupView = (rows, subfields, listData, dynamicListData, values) => {
  // const rows = getAllRows(subfields, values)
  let normalizedData = []

  rows.forEach((row) => {
    let rowData = {}
    subfields.forEach((sf) => {
      const ftId = getFieldId(sf.id)

      let value = values[getLegacySubfieldId(sf.id, row)]
      let listDataSf = []

      if (sf.data_structure === FIELD_TYPES.LIST || sf.data_structure === FIELD_TYPES.MULTILIST) {
        listDataSf = dynamicListData?.[sf.id] || listData?.[sf.id] || sf.options || []
        if (sf.data_structure === FIELD_TYPES.MULTILIST) {
          if (typeof value === 'string') {
            try {
              const parsed = JSON.parse(value)
              if (Array.isArray(parsed)) value = parsed
              else
                value = value
                  .split(',')
                  .map((v) => v.trim())
                  .filter(Boolean)
            } catch {
              value = value
                .split(',')
                .map((v) => v.trim())
                .filter(Boolean)
            }
          } else if (!Array.isArray(value)) {
            value = value ? [value] : []
          }
        } else if (sf.data_structure === FIELD_TYPES.LIST) {
          if (Array.isArray(value)) value = value[0] || ''
          if (typeof value === 'object' && value !== null) {
            value = value.value || value.label || ''
          }
        }
      }

      rowData[ftId] = {
        ...sf,
        listData: listDataSf,
        value: value,
      }
    })
    normalizedData.push(rowData)
  })
  return normalizedData
}

export const getColumns = (subfields = [], hiddenColumns = [], freezeColumnId = []) => {
  const shouldFreezeColumns = freezeColumnId?.length > 0

  let leftOffset = 50
  const zIndexBase = 100

  const slNoColumn = {
    dataKey: 'slNo',
    label: 'Sl. No.',
    width: 50,
    isFrozen: true,
    leftOffset: 0,
    zIndex: zIndexBase,
  }

  let freezeLimitReached = !shouldFreezeColumns

  const columns = subfields
    ?.filter((it) => {
      const isHidden = hiddenColumns?.includes(it.id) || it.is_hidden
      if (!isHidden) {
        return it
      }
    })
    ?.map((it) => {
      const shouldFreeze = shouldFreezeColumns && !freezeLimitReached

      if (shouldFreeze && it.id == freezeColumnId) {
        // Stop freezing after the freezeColumnId
        freezeLimitReached = true
      }

      const column = {
        dataKey: getFieldId(it.id),
        label: it.field_template_name,
        width: parseInt(it.subfield_column_width_in_rem, 10) * 16,
        numeric: it.data_structure == FIELD_TYPES.NUMBER,
        isFrozen: shouldFreeze,
        leftOffset: shouldFreeze ? leftOffset : null,
        zIndex: shouldFreeze ? zIndexBase + 10 : 1,
      }

      if (shouldFreeze) {
        leftOffset += column.width
      }
      return column
    })

  return [slNoColumn, ...columns]
}

export const getTableRows = (field, values, subfields) => {
  if (!field || subfields.length === 0) return [1]
  return Array(values[getFieldId(field.id)])
    .fill(0)
    .map((_, index) => index + 1)
    .filter((row) => values[getLegacySubfieldId(subfields[0].id, row)] != undefined)
}

export const getRowData = (
  rows,
  tableSequenceAndHeaders,
  values,
  reviews,
  subfields,
  hiddenColumns,
  listData,
  dynamicListData,
  previewCurrency
) => {
  let data = []
  tableSequenceAndHeaders.forEach(({ row, is_header, header_value }, i) => {
    let rowData = {}
    if (!is_header) {
      rowData = { ...rowData, is_header: false }
      subfields
        .filter((it) => !hiddenColumns?.includes(it))
        .forEach((sf) => {
          const _value = values[getLegacySubfieldId(sf.id, row)]
          const _review = reviews[getLegacySubfieldReviewId(sf.id, row)]

          // Handling TIMESTAMPED_BIGTEXT type
          if (sf.data_structure === FIELD_TYPES.TIMESTAMPED_BIGTEXT) {
            let actualValue = null
            if (_value && Array.isArray(_value)) {
              actualValue = _value.map((v, index) => {
                const user = dynamicListData?.users?.find((u) => u.id === v.user_id)
                const username = user ? `${user.first_name} ${user.last_name}` : null
                const lines = v.text.split('\n').map((line, i) => (
                  <span key={`${index}-${i}`}>
                    {line}
                    <br />
                  </span>
                ))
                return (
                  <div key={index}>
                    <i>{v.timestamp}:</i> {lines} {username ? ` - ${username}` : ''}
                  </div>
                )
              })
            }
            rowData = {
              ...rowData,
              [getFieldId(sf.id)]: {
                value: actualValue,
                review: _review,
                data_structure: sf.data_structure,
              },
            }
          } else if (sf.data_structure === FIELD_TYPES.LIST) {
            let actualValue = null
            if (!sf.list_id) {
              const type = sf?.dynamic_field_type?.type
              const items = dynamicListData[type]
              const item = items?.find((ld) => ld.id == _value)

              if (type == 'users') {
                actualValue = `${item?.first_name} ${item?.last_name}`
              } else {
                actualValue = item?.name
              }
            } else {
              actualValue = listData.find((ld) => ld.id == _value)?.value
            }

            rowData = {
              ...rowData,
              [getFieldId(sf.id)]: {
                value: actualValue,
                review: _review,
                data_structure: sf.data_structure,
              },
            }
          } else if (sf.data_structure === FIELD_TYPES.LIST_MULTI) {
            let actualValue = []
            if (!sf.list_id) {
              const type = sf?.dynamic_field_type?.type
              const items = dynamicListData[type]
              actualValue = _value
                ?.map((it) => {
                  const item = items.find((ld) => ld.id == it)
                  if (type == 'users') {
                    return `${item?.first_name} ${item?.last_name}`
                  } else {
                    return item?.name
                  }
                })
                ?.join(',')
            } else {
              actualValue = _value
                ?.map((it) => listData.find((ld) => ld.id == it)?.value)
                ?.join(',')
            }

            rowData = {
              ...rowData,
              [getFieldId(sf.id)]: {
                value: actualValue,
                review: _review,
                data_structure: sf.data_structure,
              },
            }
          } else if (sf.data_structure === FIELD_TYPES.FILE) {
            rowData = {
              ...rowData,
              [getFieldId(sf.id)]: {
                value: _value,
                review: _review,
                data_structure: sf.data_structure,
              },
            }
          } else {
            rowData = {
              ...rowData,
              [getFieldId(sf.id)]: {
                value:
                  sf.data_structure === FIELD_TYPES.CURRENCY
                    ? formatCurrency(_value, previewCurrency[sf.id])
                    : _value,
                review: _review,
                data_structure: sf.data_structure,
              },
            }
          }
        })
    } else {
      rowData = { is_header: true, value: header_value }
    }
    data.push(rowData)
  })

  return data
}
export const getDateAndDateTime = (value, dataStructure) => {
  if (value === null || value === undefined || !dataStructure) return ''

  if (dataStructure === FIELD_TYPES.DATE) {
    const returnValueDate = moment(value).format(FORMATS.DATE)
    return returnValueDate === 'Invalid date' ? '' : returnValueDate
  } else if (dataStructure === FIELD_TYPES.DATETIME) {
    const returnValueDateTime = moment(value).format(FORMATS.DATETIME)
    return returnValueDateTime === 'Invalid date' ? '' : returnValueDateTime
  }

  return ''
}
